if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'nbs:recently-viewed';
      this.maxStored = 24;
    }

    connectedCallback() {
      this.currentHandle = this.dataset.currentHandle || '';
      this.limit = parseInt(this.dataset.limit, 10) || 8;
      this.grid = this.querySelector('[data-recently-viewed-grid]');

      const handles = this.readStoredHandles();
      const toShow = handles.filter((handle) => handle !== this.currentHandle).slice(0, this.limit);

      // Record this visit AFTER computing the list to show, so the current
      // product never shows in its own "recently viewed" row.
      this.recordVisit(handles);

      if (!this.grid || toShow.length === 0) {
        this.hideSection();
        return;
      }

      this.renderCards(toShow);
    }

    readStoredHandles() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    recordVisit(existingHandles) {
      if (!this.currentHandle) return;
      try {
        const next = [this.currentHandle, ...existingHandles.filter((handle) => handle !== this.currentHandle)].slice(
          0,
          this.maxStored
        );
        localStorage.setItem(this.storageKey, JSON.stringify(next));
      } catch (error) {
        // Storage unavailable (private browsing, quota, etc.) -- safe to ignore,
        // the row just won't have history to draw on for this visitor.
      }
    }

    async renderCards(handles) {
      const results = await Promise.all(
        handles.map((handle) =>
          fetch(`/products/${handle}?section_id=recently-viewed-card`)
            .then((response) => (response.ok ? response.text() : ''))
            .catch(() => '')
        )
      );

      const cardsHtml = results.filter(Boolean);
      const html = cardsHtml.join('').trim();

      if (!html) {
        this.hideSection();
        return;
      }

      this.grid.innerHTML = html;
      this.fitColumnsToCount(cardsHtml.length);
      this.removeAttribute('hidden');
    }

    // A short recently-viewed history looks sparse in a wide fixed-column
    // grid (a couple of cards left-aligned with a big empty gap next to
    // them). Cap the effective column counts to however many cards are
    // actually showing, so a short row fills cleanly instead of leaving
    // dead space.
    fitColumnsToCount(count) {
      const desktopMatch = this.grid.className.match(/grid--(\d+)-col-desktop/);
      const mobileMatch = this.grid.className.match(/grid--(\d+)-col-tablet-down/);
      const desktopMax = desktopMatch ? parseInt(desktopMatch[1], 10) : 4;
      const mobileMax = mobileMatch ? parseInt(mobileMatch[1], 10) : 2;

      const desktopCols = Math.max(1, Math.min(desktopMax, count));
      const mobileCols = Math.max(1, Math.min(mobileMax, count));

      this.grid.className = this.grid.className.replace(/grid--\d+-col-desktop/, `grid--${desktopCols}-col-desktop`);
      this.grid.className = this.grid.className.replace(
        /grid--\d+-col-tablet-down/,
        `grid--${mobileCols}-col-tablet-down`
      );
    }

    hideSection() {
      this.setAttribute('hidden', '');
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
